<template>
  <div v-if="!hasPermission('List Terminal')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
    <Toolbar/>
    <div>
      <div class="container-xxl">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h3 class="card-title">Terminais</h3>
            <button v-if="false" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modal_terminal"
                    @click="openCreateModal">
              <i class="bi bi-plus-lg"></i> Novo Terminal
            </button>
          </div>
          <div class="card-body">
            <input class="form-control mb-3" v-model="search" placeholder="Pesquisar terminal..."/>
            <table class="table table-row-bordered gy-5">
              <thead>
              <tr>
                <th>Nome</th>
                <th>Tipo</th>
                <th>Ativo</th>
                <th>Hash</th>
                <th>Filas</th>
                <th style="text-align:center">Ações</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="terminal in filteredTerminals" :key="terminal.id_terminal">
                <td>{{ terminal.terminal_name }}</td>
                <td>{{ getTerminalTypeLabel(terminal.terminal_type) }}</td>
                <td>
                  <span class="badge" :class="terminal.active ? 'badge-light-success' : 'badge-light-danger'">
                    {{ terminal.active ? 'Sim' : 'Não' }}
                  </span>
                </td>
                <td>
                  <spam>
                    {{ terminal.terminal_hash }}
                    <br>
                    <em>{{ 'Incluído em: ' + date(terminal.created_at).format('DD/MM/YYYY HH:mm') }}</em>

                  </spam>

                </td>
                <td>
                  <span v-for="queue in terminal.service_queues" :key="queue.id_service_queue"
                        class="badge bg-primary opacity-75 me-1 mb-2">
                    {{ queue.service_queue_name }}
                  </span>
                </td>
                <td style="text-align:center">
                  <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                          v-if="hasPermission('Update Terminal')"
                          @click="openEditModal(terminal)" data-bs-toggle="modal" data-bs-target="#modal_terminal"
                          title="Editar">
                    <i class="bi bi-pencil-square"></i>
                  </button>
                  <button class="btn btn-icon btn-bg-light btn-active-color-primary"
                          v-if="hasPermission('Delete Terminal')"
                          @click="deleteTerminal(terminal.id_terminal)" title="Excluir">
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Modal Terminal -->
        <div class="modal fade" id="modal_terminal" tabindex="-1">
          <div class="modal-dialog">
            <form class="modal-content" @submit.prevent="saveTerminal">
              <div class="modal-header">
                <h5 class="modal-title">{{ form.id_terminal ? 'Editar Terminal' : 'Novo Terminal' }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div class="modal-body">
                <div class="mb-3">
                  <label class="form-label">Nome</label>
                  <input class="form-control" v-model="form.terminal_name" required/>
                </div>
                <div class="mb-3">
                  <label class="form-label">Tipo</label>
                  <div>
                    <div
                        v-for="type in terminalTypes"
                        :key="type.value"
                        class="form-check form-check-inline"
                    >
                      <input
                          class="form-check-input"
                          type="radio"
                          :id="'terminal_type_' + type.value"
                          v-model="form.terminal_type"
                          :value="type.value"
                          required
                      />
                      <label class="form-check-label" :for="'terminal_type_' + type.value">
                        {{ type.label }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label">Hash</label>
                  <input disabled class="form-control" v-model="form.terminal_hash"/>
                </div>
                <div class="mb-3">
                  <label class="form-check-label me-3 mb-2" for="active">
                    Ativar Terminal?
                  </label>
                  <div class="form-check form-switch d-flex align-items-center gap-2 m-0">
                    <input class="form-check-input" type="checkbox" v-model="form.active"
                           role="switch" id="active">
                    <label class="form-check-label m-0">
                      {{ form.active ? 'Sim' : 'Não' }}
                    </label>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label">Filas</label>
                  <MultiSelect
                      v-model="form.service_queues"
                      :options="serviceQueues"
                      optionLabel="service_queue_name"
                      optionValue="id_service_queue"
                      placeholder="Selecione as filas"
                      :filter="true"
                      :showClear="true"
                      class="w-100"
                  />
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
                <button type="submit" class="btn btn-primary">Salvar</button>
              </div>
            </form>
          </div>
        </div>
        <!-- Fim Modal -->
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/helpers/http'
import MultiSelect from 'primevue/multiselect'
import Toolbar from "@/components/layouts/auth/Toolbar.vue";
import Permission from '../../helpers/permission';
import alert from '@/helpers/alert';

export default {
  name: 'TerminalCrud',
  components: {
    Toolbar,
    MultiSelect
  },
  data() {
    return {
      search: '',
      terminals: [],
      serviceQueues: [],
      terminalTypes: [
        {label: 'Telão', value: 'SC'},
        {label: 'Terminal', value: 'SE'},
        {label: 'Totem', value: 'KI'}
      ],
      form: {
        id_terminal: null,
        terminal_name: '',
        terminal_type: '',
        terminal_hash: '',
        active: true,
        id_place: '',
        service_queues: []
      }
    }
  },
  computed: {
    filteredTerminals() {
      return this.terminals.filter(t =>
          t.terminal_name.toLowerCase().includes(this.search.toLowerCase())
      )
    },
    place() {
      return this.$store.state.auth.place;
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    date: moment,
    hasPermission(permission) {
      return Permission.has(permission);
    },
    async loadData() {
      this.terminals = (await http.get(`/places/${this.place.id_place}/terminals`)).data
      this.serviceQueues = (await http.get(`places/${this.place.id_place}/service-queues`)).data
    },
    openCreateModal() {
      this.form = {
        id_terminal: null,
        terminal_name: '',
        terminal_type: '',
        terminal_hash: '',
        active: true,
        id_place: this.place.id_place,
        service_queues: []
      }
    },
    openEditModal(terminal) {
      this.form = {
        id_terminal: terminal.id_terminal,
        terminal_name: terminal.terminal_name,
        terminal_type: terminal.terminal_type,
        terminal_hash: terminal.terminal_hash,
        active: terminal.active,
        service_queues: terminal.service_queues?.map(q => q.id_service_queue) || []
      }
    },
    async saveTerminal() {
      try {
        if (this.form.id_terminal) {
          await http.put(`/places/${this.place.id_place}/terminals/${this.form.id_terminal}`, this.form)
          alert.toastSuccess('Terminal atualizado com sucesso!');
        } else {
          await http.post(`/places/${this.place.id_place}/terminals`, this.form)
          alert.toastSuccess('Terminal criado com sucesso!');
        }
        await this.loadData()
        bootstrap.Modal.getInstance(document.getElementById('modal_terminal')).hide()
      } catch (e) {
        alert.toastError('Erro ao salvar o terminal.');
      }
    },
    async deleteTerminal(id) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover a forma de recebimento?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                await http.delete(`/places/${this.place.id_place}/terminals/${id}`)
                alert.toastSuccess('Terminal excluído com sucesso!');
                await this.loadData()
              } catch (e) {
                alert.toastError('Erro ao excluir o terminal.');
              }
            }
      })
    },
    getTerminalTypeLabel(value) {
      const type = this.terminalTypes.find(t => t.value === value)
      return type ? type.label : value
    }
  }
}
</script>

<style scoped>
</style>